import { createLucideIcon } from "lucide-react";

/**
 * 「はじめての方へ」のアイコン（PRODUCT_DEV-783）。初心者マーク（若葉マーク）の形。
 *
 * lucide に初心者マークが無く、デザインガイドで絵文字（🔰）は使わないので、`DiaryPenIcon` と同じく
 * `createLucideIcon` で他のアイコンと同じ線の太さ・角の丸め（24 グリッド・stroke 2・round）で描く。
 * 上が V 字にへこみ下が尖った盾形で、右半分を塗る（左右で色が違う本物に寄せる）。
 */
const BeginnerMarkIcon = createLucideIcon("beginner-mark", [
  ["path", { d: "M12 7.5 19 3v12.5L12 21l-7-5.5V3z", key: "shield" }],
  // 本物の初心者マークは左右で色が違う。右半分を塗って、線画でも初心者マークと読めるようにする
  ["path", { d: "M12 7.5 19 3v12.5L12 21z", fill: "currentColor", key: "right" }],
]);

export default BeginnerMarkIcon;
